import React from "react";
import PropTypes from "prop-types";
import {
  PrimaryButtonLink,
  PrimaryButton,
  ButtonLink,
} from "../../../components/Buttons";
import { connect } from "react-redux";
import { exportWorkers } from "../actions";
import { Organisation } from "../../Permissions/resources";
import {
  isResourceEditable,
  isResourceReadable,
} from "../../Permissions/actions";
import {
  W3Dropdown,
  W3DropdownContent,
  W3DropdownToggler,
} from "../../../components/W3Dropdown";

const mapStateToProps = (state) => ({
  permissions: state.permissions.permissionMap,
  isNGUMActive: state.ngum.isNGUMActive,
});
const mapDispatchToProps = (dispatch) => ({
  getWorkersAsCSV: (...args) => dispatch(exportWorkers(...args)),
});

const WorkerListMenu = ({
  className = "",
  permissions,
  isNGUMActive,
  getWorkersAsCSV,
}) => {
  const onExportWorkers = (event) => {
    if (event) event.preventDefault();
    getWorkersAsCSV();
  };

  const isReadable = isResourceReadable(
    Organisation.WorkerWizard.BasicInfo,
    permissions,
  );
  const isEditable = isResourceEditable(
    Organisation.WorkerWizard.BasicInfo,
    permissions,
  );
  const isImportReadable = isResourceReadable(
    Organisation.WorkerWizard.Import,
    permissions,
  );
  // const isNgumImportable = isResourceReadable(
  //   Organisation.WorkersNgumIDImport,
  //   permissions
  // );
  // if (isNGUMActive) {
  //   return null;
  // }
  return (
    <div className={`worker list-menu ${className}`}>
      {/* {isNgumImportable && (
        <PrimaryButtonLink
          className="margin-rht"
          name="importNgumIDBtn"
          to={`/wizard/organisation/ngum-id-import`}
        >
          {"Import nGUM ID"}
        </PrimaryButtonLink>
      )} */}
      {
        /* !isNGUMActive &&  */ ((isReadable && isEditable) ||
          isImportReadable) && (
          <W3Dropdown className="modems dropdown-list-menu">
            <W3DropdownToggler as={PrimaryButton} size="" name="addWorkerBtn">
              {`Mitarbeiter hinzufügen`}
            </W3DropdownToggler>
            <W3DropdownContent
              className="w3-bar-block w3-border"
              style={{ right: "0", width: "180px" }}
            >
              {isReadable && isEditable && (
                <ButtonLink
                  className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                  to={`/wizard/organisation/mitarbeiter/neu`}
                >
                  {`Einzelanlage`}
                </ButtonLink>
              )}
              {isImportReadable && (
                <>
                  <a href="#" className="w3-bar-item separator">
                    <div
                      className="w3-border-top"
                      style={{ margin: "0 -4px" }}
                    />
                  </a>
                  <ButtonLink
                    className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                    to={`/wizard/organisation/mitarbeiterimport`}
                  >
                    {`Import`}
                  </ButtonLink>
                </>
              )}
            </W3DropdownContent>
          </W3Dropdown>
        )
      }
      {
        /* !isNGUMActive */ true && (
          <PrimaryButton
            className="margin-lft"
            name="exportWorkerBtn"
            onClick={onExportWorkers}
          >
            {"CSV Exportieren"}
          </PrimaryButton>
        )
      }
    </div>
  );
};

WorkerListMenu.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  permissions: PropTypes.shape({}).isRequired,
  isNGUMActive: PropTypes.bool,
  getWorkersAsCSV: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkerListMenu);
